import {
     ShareBaseDocument, 
     ShareBaseFolder,
     ShareBaseLibrary ,
     AsyncOpStatus
} from 'phoenix/domain';

export interface PhoenixTrashItem {
    ItemName:string;
    ItemType: 'document' | 'folder';
    DateDeleted:string;
    DeletedByUserName:string;
    Embedded: {
        Document?:PhoenixTrashContent<ShareBaseDocument>;
        Folder?:PhoenixTrashContent<ShareBaseFolder>;
        ParentLibrary:ShareBaseLibrary;
    };
    Links: {
        RestoreUri:string;
        FolderIconUri:string;
    }
}

export function isTrash(item):item is PhoenixTrashItem{
    let t = item as PhoenixTrashItem;
    return angular.isDefined(t) &&
        angular.isDefined(t.DateDeleted)
        && angular.isDefined(t.DeletedByUserName);
}

type PhoenixTrashContent<T extends (ShareBaseDocument | ShareBaseFolder)> = T & { 
    AsyncPurgeOpStatus:AsyncOpStatus;
    AsyncTrashOpStatus:AsyncOpStatus;
};


// WEBPACK FOOTER //
// ./src/phoenix/domain/phoenix-trash-item.ts